export const position_nrw = [
  {
    x: -96.1469,
    y: 314.5929,
    w: 232.6443,
    d: 0,
  },
  {
    x: 148.1253,
    y: 366.0378,
    w: 152.67,
    d: 0,
  },
  {
    x: 304.1139,
    y: 273.9801,
    w: 175.9752,
    d: 26,
  },
  {
    x: -29.8889,
    y: 235.754,
    w: 94.8054,
    d: 27,
  },
  {
    x: 90.9453,
    y: 248.4207,
    w: 150.226,
    d: 333,
  },
  {
    x: 245.4858,
    y: 231.8593,
    w: 75.3078,
    d: 18,
  },
  {
    x: 361.2717,
    y: 200.686,
    w: 119.1341,
    d: 343,
  },
  {
    x: -31.5274,
    y: 132.0615,
    w: 95.0823,
    d: 320,
  },
  {
    x: 112.7646,
    y: 150.3836,
    w: 84.4901,
    d: 30,
  },
  {
    x: 180.5818,
    y: 85.6865,
    w: 84.7375,
    d: 320,
  },
  {
    x: 283.0985,
    y: 76.5929,
    w: 160.4204,
    d: 38,
  },
];
